module.exports = __webpack_public_path__ + "img/logo-2.b4e21a52.webp";